import StickySubmitButton from '@/components/StickySubmitButton';
import { Form, TextArea, ImageUploader, Toast, Dialog } from 'antd-mobile';
import styles from './index.less';
import { PlusOutlined } from '@ant-design/icons';

const RepairContent = () => {
  const [form] = Form.useForm();
  const handleCancel = async () => {
    console.log('cancel');
    await Dialog.confirm({
      title: '退出确认',
      content: '资料尚未提交，是否取消编辑？',

      onConfirm: () => {
        Toast.show('取消');
      },
      onCancel: () => {
        Toast.show('继续编辑');
      },
    });
  };

  const handleSubmit = () => {
    console.log('submit');
  };

  const handleUpload = async (file: File) => {
    console.log(file, 'file');
    return {
      url: URL.createObjectURL(file),
    };
  };

  const beforeUpload = (file: File) => {
    if (file.size > 1024 * 1024) {
      Toast.show('文件大小不能超过1M');
      return null;
    }
    return file;
  };

  return (
    <div className={styles.container}>
      <Form className={styles.form} form={form}>
        <div className={styles.label}>
          内容<span>*</span>
        </div>
        <Form.Item noStyle name={'content'} rules={[{ required: true }]}>
          <TextArea
            className={styles.value}
            rows={4}
            placeholder={'请输入工单内容'}
          />
        </Form.Item>
        <div className={styles.label}>
          详细地址<span>*</span>
        </div>
        <Form.Item noStyle name={'address'} rules={[{ required: true }]}>
          <TextArea
            className={styles.value}
            rows={1}
            placeholder={'请输入地址'}
          />
        </Form.Item>
        <div className={styles.label}>
          上传照片<span>*</span>
          <section>仅支持上传一张图片，文件大小不超过1M</section>
        </div>
        <Form.Item noStyle name={'file'} rules={[{ required: true }]}>
          <ImageUploader
            upload={(file) => handleUpload(file)}
            beforeUpload={beforeUpload}
            maxCount={1}
          >
            <div className={styles.upload}>
              <PlusOutlined />
              <p>上传照片或截图</p>
            </div>
          </ImageUploader>
        </Form.Item>
      </Form>
      <StickySubmitButton
        defaultBtnClick={handleCancel}
        submitBtnClick={handleSubmit}
      />
    </div>
  );
};

export default RepairContent;
